import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'
import { GET_AP_CONTEXT_DATA } from '@landscape/gql'

export function useApContextDataGql(aiCode?: string) {
    const [fetch, res] = useLazyQuery(GET_AP_CONTEXT_DATA,
                                      { fetchPolicy: 'cache-and-network' });
  
    useEffect(() => { if (aiCode) fetch({ variables: { ai_code: aiCode } }); },
              [aiCode, fetch]);
  
    return { data: res.data, loading: res.loading, error: res.error };
  }
  